// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { billingAndShippingAddressStyles } from "@tps/Overrides/Widgets/CheckoutReviewAndSubmit/BillingAndShippingInfo";
import xScreen from "@tps/XDL/Utilities/xScreen";
import { css } from "styled-components";

billingAndShippingAddressStyles.container = {
    gap: 0,
    offsetCss: css`
        justify-content: space-between;
        row-gap: 20px;
    `,
};
billingAndShippingAddressStyles.shippingAddressGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        padding-left: 22px;
        justify-content: flex-end;
        ${xScreen("lte", "md")} {
            padding-left: 0;
            justify-content: flex-start;
        }
    `,
};
billingAndShippingAddressStyles.shippingAddressSectionWrapper = {
    css: css`
        width: 430px;
        max-width: 100%;
        ${xScreen("lte", "md")} {
            width: 360px;
        }
        ${xScreen("lte", 767)} {
            width: 100%;
        }
    `,
};
billingAndShippingAddressStyles.billingAddressGridItem = {
    width: [12, 12, 12, 6, 6],
};
billingAndShippingAddressStyles.billinigAndOrderDetails = {
    css: css`
        display: flex;
        flex-direction: column;
        &&& {
            width: 430px;
            max-width: 100%;
            ${xScreen("lte", "md")} {
                max-width: 100%;
                width: 100%;
            }
        }
    `,
};
billingAndShippingAddressStyles.wrapper = {
    css: css`
        width: 100%;
    `,
};

billingAndShippingAddressStyles.pickupAddressGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

billingAndShippingAddressStyles.pickupAddressInfoGridItem = { width: 12 };

billingAndShippingAddressStyles.pickupAddressWrapper = {
    css: css`
        width: 430px;
        max-width: 100%;
        ${xScreen("lte", "md")} {
            width: 360px;
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

billingAndShippingAddressStyles.pickupWarehousesText = {
    as: "p",
    css: css`
        font-size: 14px;
        line-height: 22px;
    `,
};

billingAndShippingAddressStyles.headingText = {
    variant: "h5",
    forwardAs: "p",
};

billingAndShippingAddressStyles.headingGridItem = { width: 12 };

billingAndShippingAddressStyles.pickupAddressContainer = { gap: 0 };

billingAndShippingAddressStyles.pickupAddressInfoWrapper = {
    css: css`
        font-style: normal;
    `,
};
